(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lande-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const normalise = (valeur) =>
      (valeur || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    const brancher = (racine) => {
      const champ = racine.querySelector('[data-lande-faq-champ]');
      if (!champ || champ.dataset.landePret === 'true') return;
      champ.dataset.landePret = 'true';

      const boite = racine.querySelector('[data-lande-faq-recherche]');
      const compte = racine.querySelector('[data-lande-faq-compte]');
      const vide = racine.querySelector('[data-lande-faq-vide]');
      const questions = Array.from(racine.querySelectorAll('[data-lande-faq-q]'));
      const groupes = Array.from(racine.querySelectorAll('[data-lande-faq-groupe]'));

      if (boite) boite.hidden = false;

      const filtrer = () => {
        const terme = normalise(champ.value).trim();
        let total = 0;

        questions.forEach((question) => {
          const visible = terme === '' || normalise(question.textContent).includes(terme);
          question.hidden = !visible;
          if (visible) total += 1;
        });

        groupes.forEach((groupe) => {
          groupe.hidden = groupe.querySelectorAll('[data-lande-faq-q]:not([hidden])').length === 0;
        });

        if (vide) vide.hidden = terme === '' || total > 0;
        if (compte) {
          compte.textContent = terme === '' ? '' : (compte.dataset.gabarit || '').replace('{n}', String(total));
        }
      };

      champ.addEventListener('input', filtrer);

      const demande = new URLSearchParams(window.location.search).get('q');
      if (demande) {
        champ.value = demande;
        filtrer();
      }
    };

    const init = (portee) => {
      (portee || document).querySelectorAll('.lande-faq').forEach(brancher);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init());
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (evenement) => init(evenement.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
